import { render, staticRenderFns } from "./FileDocumentMultipleIcon.vue?vue&type=template&id=1ba2c3ab"
import script from "./FileDocumentMultipleIcon.vue?vue&type=script&lang=js"
export * from "./FileDocumentMultipleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports